import React from "react";
import { NavLink } from "react-router-dom";

export default function Library(props) {
  return (
    <div className="main-page">
      <h1>Library</h1>
      <div>
        <h2>Comming Soon!</h2>
        <p>
          A new way to learn and review Hebrew vocabulary words. Using the
          diglot weave method, you will be able to learn and review Hebrew words
          in context. This will help you to learn the words in a more natural
          way, and will help you to remember them better. How? By blending the
          Hebrew words into English sentences, you will be able to learn the
          words in context, and you will be able to see how the words are used
          in real life. This will help you to remember the words better, and
          will help you to learn how to use the words in your own sentences.
        </p>
      </div>
      <NavLink to="/add-new-text">
        <button>Add New</button>
      </NavLink>
    </div>
  );
}
